module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Medium.e68e938a.otf";